export type RepresentativeContact = {
  city: string;
  phone: string;
  email: string;
};

/** Строка «Представитель г.Владикавказ +7...» в адресе города выносится отдельно. */
export function splitRepresentative(address: string | null | undefined): {
  address: string;
  representative: RepresentativeContact | null;
} {
  const lines = String(address ?? "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const addressLines: string[] = [];
  let city = "";
  let phone = "";
  let email = "";

  for (const line of lines) {
    const representative = line.match(
      /^Представитель\s+(?:г\.?\s*)?(.+?)\s+(\+[\d()\-\s]+)$/i
    );
    if (representative) {
      city = representative[1].trim();
      phone = representative[2].trim();
      continue;
    }
    if (city && !email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(line)) {
      email = line;
      continue;
    }
    addressLines.push(line);
  }

  return {
    address: addressLines.join("\n"),
    representative: city ? { city, phone, email } : null,
  };
}
